import { FormWrapperInputComponent, HeaderListComponent, LoadingComponent, PageListComponent } from 'containers/backend/common/component/Index'
import React, { useCallback, useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import './AppUIDetail.less'
import DEFINE, {
    DETAIL_ACTIONS,
    CAMPAIGN as CAMPAIGN_ENUM,
    PATHS,
    MARKUP,
    FEATURE_FLAGS,
    CAMPAIGN,
    UPLOAD_DIRECTORY
  } from "constants/Define";
import TranslateButton from 'containers/backend/common/component/TranslateButton'
import { FormActionComponent, FormWrapperItem } from 'containers/backend/common/component/Index'
import Wrapper from 'containers/backend/common/component/Wrapper'
import Input from 'containers/backend/common/component/Input'
import AntSelect, { AntOption } from 'containers/backend/common/component/AntSelect'
import {screenTypeEnum} from 'constants/Define'
import { Switch, Tooltip } from 'antd'
import { formatValidation, multipleValidate } from 'helpers/functions'
import UploadImage from 'containers/backend/common/component/UploadImage'
import * as Func from 'helpers/functions';

import { isEmpty } from 'lodash'
import Modal from 'containers/backend/common/component/Modal'
import { useGetDetailAppUI } from 'hooks/appUI/useGetDetailAppUI'

const AppUIDetail = (props) => {
    //! State
    const {id: idAppUi} = useParams();
    const [action, setAction] = useState(idAppUi ? DETAIL_ACTIONS.UPDATE : DETAIL_ACTIONS.CREATE);
    const {t, match, uploadState, appUIState, tourState} = props;
    const {tourTypes} = tourState;
    const [defaultLanguageCode, setDefaultLanguageCode] = useState(undefined);
    const {data: appUIDetail, isLoading, error, reload} = useGetDetailAppUI(idAppUi);
    const [appUIData, setAppUIData] = useState({
      screenType: 1,
      backgroundName: '',
      title: '',
      descriptions: '',
      order: '',
      logoImageName: '',
      logoImageNameUrl: '',
      backgroundImageName: '',
      backgroundImageNameUrl: '',
      isDisplay: true,
      translations: [],
      languageCode: undefined,
      tourTypeId: undefined,
    })
    const [validation, setValidation] = useState({});
    const [isActionButton, setIsActionButton] = useState(action === DETAIL_ACTIONS.CREATE ? false : true);
    //! Function
    const onSubmit = (e) => {
      e.preventDefault();
      if(validate()){
        if(action === DETAIL_ACTIONS.CREATE) {
          props.createNewAppUI({...appUIData})
        }
        if(action === DETAIL_ACTIONS.UPDATE) {
          props.updateAppUIConfig({...appUIData, id: idAppUi})
        }

        if(action === DETAIL_ACTIONS.TRANSLATE) {
          if(appUIData?.translations?.some(el => el.languageCode === appUIData.languageCode)){
            //update
            props.updateNewAppTranslation({...appUIData, id: idAppUi})
          }else{
            //create
            props.createNewAppTranslation({...appUIData, id: idAppUi})
          }
        }
      }
    }

    const onClickBack = () => {
      props.history.push(PATHS.APP.LIST.path)
    }

    const onChangeDetail = (name, value) => {
      if(name === 'order'){
        setAppUIData({...appUIData,[name]: value >= 0 ? value : 1})
      }else{
        setAppUIData({...appUIData,[name]: value})
      }
    }

    const handleToggleDisplay = () => {
      setAppUIData({...appUIData,isDisplay: !appUIData.isDisplay})
    }

    const getThumbSources = (image) => {
      return image ? [`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${image}`] : [];
    }
    //* handle upload img

    const onUploadImage = (file, fieldName) => {
      props.uploadFile({file: file.target.files[0],directory: UPLOAD_DIRECTORY.APP_UI,isFile: 1, fieldName})
    }

    const onRemoveImage = (url, fieldName) => {
      if(!url) return;
      setAppUIData({...appUIData,[fieldName]: '',[`${fieldName}Url`]:''});
    }

    //* handle change translate

    const onShowTranslate = (language) => {
      if(!isEmpty(appUIDetail)){
        const translationData = (appUIDetail.translations || []).find(el => el.languageCode === language.code);
        const data = appUIData;
        data['title'] = translationData?.title ?? '';
        data['descriptions'] = translationData?.descriptions ?? translationData?.description ?? '';
        data['logoImageName'] = translationData?.logoImage.fileName ?? appUIDetail?.logoImage?.filename;
        data['logoImageNameUrl'] = translationData?.logoImage.fileUri ?? appUIDetail?.logoImage?.fileUri;
        data['backgroundImageName'] = translationData?.backgroundImage.fileName ?? appUIDetail?.backgroundImage?.filename;
        data['backgroundImageNameUrl'] = translationData?.backgroundImage.fileUri ?? appUIDetail?.backgroundImage?.fileUri;
        data['languageCode'] = language.code;
        setAppUIData({...appUIData,...data});
        if(idAppUi){
          setAction(DETAIL_ACTIONS.TRANSLATE)
        }
      }
    }

    const onExitTranslate = () => {
      setAction(DETAIL_ACTIONS[idAppUi ? 'UPDATE' : 'CREATE']);
      setAppUIData({...appUIData,languageCode: undefined});
    }

    const onRemoveTranslate = (language) => {
      props.deleteAppTranslation({...appUIData, languageCode: language.code});
    }

    //*validate

    const validate = () => {
      const validate = {
        required: {
          screenType: formatValidation(t('validation.statusCode.code.1'), t(`item.app.screenType`)),
          backgroundName: formatValidation(t('validation.statusCode.code.1'), t(`item.app.backgroundName`)),
          title: formatValidation(t('validation.statusCode.code.1'), t(`item.app.title`)),
          // descriptions: formatValidation(t('validation.statusCode.code.1'), t(`item.app.descriptions`)),
          order: formatValidation(t('validation.statusCode.code.1'), t(`item.app.order`)),
          // logoImageName: formatValidation(t('validation.statusCode.code.1'), t(`item.app.logoImageNameUpload`)),
          backgroundImageName: formatValidation(t('validation.statusCode.code.1'), t(`item.app.backgroundImageNameUpload`)),

          // isDisPlay: formatValidation(t('validation.statusCode.code.1'), t(`item.app.isDisplay`))
        }
      }
      if(appUIData?.screenType !== 3){
        validate.required.logoImageName = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.app.logoImageNameUpload`));
      }
      if(appUIData?.screenType === 3){
        validate.required.tourTypeId = Func.formatValidation(t('validation.statusCode.code.1'), t('item.app.tourTypeId'));
        validate.required.descriptions = Func.formatValidation(t('validation.statusCode.code.1'), t('item.app.descriptions'));
      }
      if(action === DETAIL_ACTIONS.CREATE) {
        validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
      }
      let valueValidate = {};
      let result  = multipleValidate({...appUIData}, validate, valueValidate);
      setValidation(result);
      return Object.keys(result).length < 1;
    }
    //! Effect

    useEffect(() => {
      if(appUIState.isReloadData) {
        reload && reload();
      }
    },[appUIState.isReloadData])

    useEffect(() => {
      const {fieldName, file} = uploadState;
      if(fieldName && file) {
        appUIData[fieldName] = file.data.fileName;
        appUIData[`${fieldName}Url`] = file.data.fileUrl;
      }
    },[uploadState])

    useEffect(() => {
        if(!isEmpty(appUIDetail)){
          const appUIState = appUIData;
          appUIState['screenType'] = appUIDetail?.screenType ?? undefined;
          appUIState['backgroundName'] =  appUIDetail?.backgroundName ?? '';
          appUIState['title'] =  appUIDetail?.title ?? '';
          appUIState['descriptions'] =  appUIDetail?.description ?? '';
          appUIState['order'] =  appUIDetail?.order ?? '';
          appUIState['logoImageName'] =  appUIDetail?.logoImage?.filename ?? undefined;
          appUIState['logoImageNameUrl'] =  appUIDetail?.logoImage?.fileUri ?? '';
          appUIState['backgroundImageName'] =  appUIDetail?.backgroundImage?.filename ?? undefined;
          appUIState['backgroundImageNameUrl'] =  appUIDetail?.backgroundImage?.fileUri ?? '';
          appUIState['isDisplay'] =  appUIDetail?.isDisplay ?? true;
          appUIState['translations'] =  appUIDetail?.translations ?? [];
          appUIState['tourTypeId'] = appUIDetail?.tourTypeId ?? undefined;
          if(appUIDetail?.translations){
            appUIState['languageCode'] = appUIDetail?.translations?.find(el => el.isDefault === true)?.languageCode;
            setAppUIData({...appUIState});
            setDefaultLanguageCode(appUIDetail?.translations?.find(el => el.isDefault === true).languageCode);
          } 
          setAction(DETAIL_ACTIONS.UPDATE)
        }
    },[appUIDetail])
    useEffect(() => {
      if(appUIData.languageCode === undefined){
        const appUIState = appUIData;
        appUIState['screenType'] = appUIDetail?.screenType ?? undefined;
        appUIState['backgroundName'] =  appUIDetail?.backgroundName ?? '';
        appUIState['title'] =  appUIDetail?.title ?? '';
        appUIState['descriptions'] =  appUIDetail?.description ?? '';
        appUIState['order'] =  appUIDetail?.order ?? '';
        appUIState['logoImageName'] =  appUIDetail?.logoImage?.filename ?? '';
        appUIState['logoImageNameUrl'] =  appUIDetail?.logoImage?.fileUri ?? '';
        appUIState['backgroundImageName'] =  appUIDetail?.backgroundImage?.filename ?? '';
        appUIState['backgroundImageNameUrl'] =  appUIDetail?.backgroundImage?.fileUri ?? '';
        appUIState['isDisplay'] =  appUIDetail?.isDisplay ?? true;
        appUIState['translations'] =  appUIDetail?.translations ?? [];
        appUIState['languageCode'] = defaultLanguageCode;
        setAppUIData({...appUIState})
      }
    },[appUIData.languageCode])
    useEffect(() => {
      if(action === DETAIL_ACTIONS.UPDATE) {
        if(appUIData.screenType !== appUIDetail.screenType || 
          appUIData.backgroundName !== appUIDetail.backgroundName || 
          appUIData.title !== appUIDetail.title || 
          appUIData.descriptions !== appUIDetail.description || 
          appUIData.order !== appUIDetail.order || 
          appUIData.logoImageName !== appUIDetail.logoImageName || 
          appUIData.backgroundImageName !== appUIDetail.backgroundImageName || 
          appUIData.isDisplay !== appUIDetail.isDisplay ||
          appUIData.tourTypeId !== appUIDetail.tourTypeId){
            setIsActionButton(false);
        }else{
          setIsActionButton(true);
        }
      }

      if(action === DETAIL_ACTIONS.TRANSLATE){
        const translationDetail = appUIDetail?.translations?.find(el => el.languageCode === appUIData.languageCode);
        if(!translationDetail || 
            translationDetail.title !== appUIData.title || 
            translationDetail.description !== appUIData.descriptions || 
            translationDetail.logoImage.filename !== appUIData.logoImageName || 
            translationDetail.backgroundImage.filename !== appUIData.backgroundImageName) {
          setIsActionButton(false);
        }else{
          setIsActionButton(true);
        }
      }

    },[appUIData])

    useEffect(() => {
      props.getAllTourTypes()
    },[])
    //! Render
  return (
    <LoadingComponent spinning={isLoading || false}>
        <PageListComponent className="app-ui-detail-page">
            <HeaderListComponent
                path={match.path}
                groupPath={'appui'}
                titleHeader={idAppUi ? t('navigation.appUIUpdate') : t('navigation.appUICreate')}
                componentRight={
                    FEATURE_FLAGS.TRANSLATE_ENABLE && (
                        <TranslateButton
                          languages={appUIData.translations}
                          current={appUIData.languageCode}
                          validation={validation.languageCode}
                          onChange={onShowTranslate}
                          onClear={onExitTranslate}
                          defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                          onSelectDefault = {language => onChangeDetail('languageCode',language.code)}
                          onRemove={onRemoveTranslate}
                        />
                    )
                }
            />
            
            <FormActionComponent
              onSubmit={onSubmit}
              isGetItem={false}
              action={action}
              onClickBack={onClickBack}
              submitButtonRight={ true }
              isSubmit={appUIState.isLoading}
              isDisableAction={isActionButton}
            >
              <FormWrapperItem>
                  <Wrapper className="col-md-6 mt-3">
                    {appUIData?.screenType !== 3 && 
                    (<Wrapper className="col-md-12">
                      <FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        validation={validation.logoImageName}
                        messageBelowInput={true}
                        labelTitle={t('item.app.logoImageNameUpload')}
                      >
                          <div className='subtitle'>{t('item.app.subTitleLogoImageNameUpload')}</div>
                        <UploadImage 
                          multiple={false}
                          isPreview3x3={true}
                          loading={uploadState.fieldName === 'logoImageName'}
                          thumbnailSize={'100%'}
                          buttonSize={180}
                          thumbnailStyle={{ maxHeight: 180 }}
                          uploadText={t('item.app.uploadFile')}
                          loadingText={t('item.app.uploading')}
                          onChange={(file) => onUploadImage(file, 'logoImageName')}
                          onRemoveThumbnail={(url) => onRemoveImage(url, 'logoImageName')}
                          thumbnails={getThumbSources(appUIData.logoImageNameUrl)}
                        />
                      </FormWrapperInputComponent>
                    </Wrapper>)
                    }
                    <Wrapper className="col-md-12">
                      <FormWrapperInputComponent
                          isRequired={true}
                          isValidation={true}
                          validation={validation.backgroundImageName}
                          messageBelowInput={true}
                          labelTitle={t('item.app.backgroundImageNameUpload')}
                        >
                          <div className='subtitle'>{t('item.app.subTitleBackgroundImageNameUpload')}</div>
                          <UploadImage 
                            multiple={false}
                            isPreview3x3={true}
                            loading={uploadState.fieldName === 'backgroundImageName'}
                            thumbnailSize={'100%'}
                            buttonSize={180}
                            thumbnailStyle={{ maxHeight: 180 }}
                            uploadText={t('item.app.uploadFile')}
                            loadingText={t('item.app.uploading')}
                            onChange={(file) => onUploadImage(file, 'backgroundImageName')}
                            onRemoveThumbnail={(url) => onRemoveImage(url, 'backgroundImageName')}
                            thumbnails={getThumbSources(appUIData.backgroundImageNameUrl)}
                          />
                        </FormWrapperInputComponent>
                    </Wrapper>
                  </Wrapper>
                  <Wrapper className="col-md-6 mt-3">
                    <Wrapper className="col-md-12">
                      <FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        validation={validation.screenType}
                        messageBelowInput={true}
                        labelTitle={t('item.app.screen')}
                      >
                        <AntSelect className="select-departure"
                                    showArrow
                                    disabled={action === DETAIL_ACTIONS.TRANSLATE || (action === DETAIL_ACTIONS.UPDATE && appUIData.screenType === 3)}
                                    name="screenType"
                                    value={appUIData.screenType}
                                    placeholder={t('item.app.screen')}
                                    style={{width: '100%'}}
                                    onChange={(e) => onChangeDetail('screenType',e)}
                        >
                         { (screenTypeEnum || []).map(el => (
                              <AntOption key={ el.value } value={ el.value }>
                                  <Tooltip title={ el.text } placement="topLeft">{el.text}</Tooltip>
                              </AntOption>
                          )) }
                        </AntSelect>

                      </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                      <FormWrapperInputComponent
                        labelTitle={t('item.app.backgroundName')}
                        isRequired={true}
                        isValidation={true}
                        messageBelowInput={true}
                        validation={validation.backgroundName}
                      >
                        <Input
                          placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.app.backgroundName")).toLowerCase())}
                          type='text'
                          disabled={action === DETAIL_ACTIONS.TRANSLATE}
                          className='form-control'
                          name='backgroundName'
                          onChange={(e) => onChangeDetail(e.target.name, e.target.value)}
                          value={appUIData.backgroundName}
                        />
                      </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                      <FormWrapperInputComponent
                        labelTitle={t('item.app.title')}
                        isRequired={true}
                        isValidation={true}
                        messageBelowInput={true}
                        validation={validation.title}
                      >
                        <Input
                          placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.app.title")).toLowerCase())}
                          type='text'
                          className='form-control'
                          name='title'
                          onChange={(e) => onChangeDetail(e.target.name, e.target.value)}
                          value={appUIData.title}
                        />
                      </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                      <FormWrapperInputComponent
                        labelTitle={t('item.app.descriptions')}
                        isRequired={appUIData.screenType === 3}
                        isValidation={appUIData.screenType === 3}
                        messageBelowInput={true}
                        validation={validation.descriptions}
                      >
                        <Input
                          placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.app.screenType")).toLowerCase())}
                          type='text'
                          className='form-control'
                          name='descriptions'
                          onChange={(e) => onChangeDetail(e.target.name, e.target.value)}
                          value={appUIData.descriptions}
                        />
                      </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                      <FormWrapperInputComponent
                        labelTitle={t('item.app.order')}
                        isRequired={true}
                        isValidation={true}
                        messageBelowInput={true}
                        validation={validation.order}
                      >
                        <Input
                          placeholder=''
                          type='number'
                          className='form-control'
                          disabled={action === DETAIL_ACTIONS.TRANSLATE}
                          name='order'
                          value={appUIData.order}
                          onChange={(e) => onChangeDetail(e.target.name, e.target.value)}
                        />
                      </FormWrapperInputComponent>
                    </Wrapper>
                    {appUIData?.screenType === 3 &&
                    (<Wrapper className="col-md-12">
                      <FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        validation={validation.tourTypeId}
                        messageBelowInput={true}
                        labelTitle={t('item.app.tourTypeId')}
                      >
                        <AntSelect className="select-departure"
                                    showArrow
                                    disabled={action === DETAIL_ACTIONS.TRANSLATE}
                                    name="tourTypeId"
                                    value={appUIData.tourTypeId}
                                    placeholder={t('item.app.tourTypeId')}
                                    style={{width: '100%'}}
                                    onChange={(e) => onChangeDetail('tourTypeId',e)}
                        >
                         { (tourTypes || []).map(el => (
                              <AntOption key={ el.id } value={ el.id }>
                                  <Tooltip title={ el.name } placement="topLeft">{el.name}</Tooltip>
                              </AntOption>
                          )) }
                        </AntSelect>
                      </FormWrapperInputComponent>
                    </Wrapper>)
                    }
                    <Wrapper className="col-md-12">
                      <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t('item.app.isDisplay')}
                        isRequired={true}
                        isValidation={true}
                        messageBelowInput={true}
                        validation={validation.isDisplay}
                      >
                        <Wrapper>
                          <Switch defaultChecked disabled={action === DETAIL_ACTIONS.TRANSLATE} checked={appUIData.isDisplay} onChange={handleToggleDisplay}/>
                        </Wrapper>
                      </FormWrapperInputComponent>
                    </Wrapper>
                  </Wrapper>
              </FormWrapperItem>
            </FormActionComponent>
        </PageListComponent>
    </LoadingComponent>
  )
}

export default withTranslation()(AppUIDetail)